import schema, { getUserKey } from './User.schema';
import { denormalize } from 'normalizr';
import get from 'lodash/get';
import { getStore as getDB } from '../../../common/state/db/DB.store';

export const DOMAIN = `db.${schema.key}`;

export const getStore = state => get(state, DOMAIN) || {};

export const getEntityById = (state, id) => denormalize(getUserKey(id), schema, getDB(state)) || {};
export const getEntitiesForIds = (state, ids) =>
    denormalize(ids?.map(getUserKey), [schema], getDB(state));

export const getEntityFieldById = (state, { id, field }) =>
    get(getStore(state), [getUserKey(id), field]) || null;

export const getOrganizations = (state, id) => get(getEntityById(state, id), 'organizations') || [];

export const getRoles = (state, id) => get(getEntityById(state, id), 'roles') || [];
